<h2
  mat-dialog-title
  class="!font-poppins !text-md !text-primary-900 !font-semibold">
  TÉRMINOS Y CONDICIONES DE USO Y CONTRATACIÓN – MOTOR DE VUELOS (TOURBOOK)
</h2>
<mat-dialog-content class="mat-typography">
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    1. Identificación de la empresa
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    Esta plataforma (el “Motor de Vuelos” o la “Plataforma”) pertenece a
    CARNIVAL S.R.L. (“CARNIVAL TOURS”), Consolidador Aéreo. Domicilio: Maipú
    471, Piso 11, CP 1006, CABA, Argentina. CUIT: 30-67657993-8 Email de
    atención al cliente: soportetourbo&#64;carnival-tours.com Email de
    privacidad: soportetourbo&#64;carnival-tours.com Teléfono: 011 5239-9500
    Horario de atención: 09:30 a 18:30 (hora Argentina) Sede legal y
    jurisdicción: CABA
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    2. Aceptación de términos
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    El acceso y uso de la Plataforma implica la aceptación plena de estos
    Términos y Condiciones (“TyC”). Si no los acepta, no utilice la Plataforma.
    CARNIVAL TOURS puede actualizar contenidos y funcionalidades sin previo
    aviso.
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    3. Alcance y rol de CARNIVAL TOURS (Consolidador)
  </h3>

  <p class="font-poppins text-xs text-primary-700 font-medium">
    3.1. Intermediación tecnológica B2B. CARNIVAL TOURS actúa exclusivamente
    como consolidador y proveedor tecnológico entre el usuario (agencia/cliente
    corporativo) y los proveedores (aerolíneas, GDS, otros consolidadores). 3.2.
    Nombramiento. El Cliente nombra a CARNIVAL TOURS como su agente tecnológico
    para gestionar búsquedas, reservas y confirmaciones en los mercados donde
    CARNIVAL TOURS opere. 3.3. Perfeccionamiento. La confirmación definitiva de
    una reserva aérea se produce con la emisión del ticket por el proveedor.
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    4. Uso de la Plataforma
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    4.1. Capacidad y veracidad: El usuario declara ser mayor de 18 años o contar
    con representación suficiente. 4.2. Conducta: Queda prohibido el uso
    fraudulento, scraping o automatismos no autorizados. 4.3. Datos de
    pasajeros: El usuario es responsable por la veracidad de la información
    ingresada. 4.4. Acceso B2B: Las credenciales son personales e
    intransferibles. CARNIVAL TOURS puede revocar accesos por uso indebido.
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    5. Proceso de reserva aérea
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    Incluye búsqueda, selección, confirmación, documentación, ticketing y
    limitaciones en reservas grupales (9+ pax).
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    6. Precios, impuestos y facturación
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    La Plataforma puede mostrar precios en ARS o USD. El tipo de cambio será el
    que defina el proveedor/pasarela. No hay pagos en la Plataforma; la emisión
    se realiza fuera de ella. CARNIVAL TOURS emite Factura A y/o B según
    corresponda.
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    7. Servicios incluidos / no incluidos
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    Incluye lo indicado en la tarifa. No incluye equipaje, asientos, SSR,
    comidas o servicios adicionales salvo mención expresa.
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    8. Documentación y requisitos sanitarios
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    El pasajero es responsable de contar con pasaporte, visas, vacunas y
    permisos exigidos por autoridades. CARNIVAL TOURS no se responsabiliza por
    rechazos migratorios.
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    9. Cambios, cancelaciones y no-show
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    Las condiciones dependen de la tarifa adquirida. Muchas tarifas no son
    reembolsables ni permiten cambios. El no-show puede implicar penalidad 100%.
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    10. Reembolsos
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    Proceden únicamente si la regla tarifaria lo permite. Se tramitan por
    canales del proveedor. Diferencias de tipo de cambio o comisiones bancarias
    pueden afectar el monto final.
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    11. Conducta, fraude y bloqueos
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    Bloqueos de cupos o reservas ficticias podrán ser cancelados y generar
    cargos administrativos.
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    12. Responsabilidad de CARNIVAL TOURS
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    Actúa como consolidador bajo normativa aplicable. No responde por fuerza
    mayor, huelgas, clima o hechos de terceros. La responsabilidad máxima se
    limita al precio del servicio tecnológico provisto.
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    13. Privacidad y protección de datos
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    CARNIVAL TOURS cumple con la Ley 25.326. Datos se usan para reservas,
    emisión y soporte. Derechos de acceso y rectificación:
    soportetourbo&#64;carnival-tours.com
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    14. Comunicaciones electrónicas
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    Se consideran válidas las notificaciones al email informado por el Cliente.
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    15. Servicios complementarios
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    Traslados y otros servicios contratados fuera del motor se rigen por las
    condiciones del proveedor correspondiente.
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    16. Confidencialidad y mercados (B2B)
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    Las condiciones y tarifas son confidenciales y válidas para mercados
    autorizados por CARNIVAL TOURS.
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    17. Menores y autorizaciones
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    Los menores deben cumplir con normativa migratoria y contar con permisos
    correspondientes.
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    18. Jurisdicción y resolución de conflictos
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    Las controversias podrán someterse al Tribunal Arbitral de AAAVyT o a la
    justicia ordinaria de CABA.
  </p>
  <h3 class="font-poppins text-sm text-secondary-600 font-semibold mt-4 mb-2">
    19. Modificaciones y vigencia
  </h3>
  <p class="font-poppins text-xs text-primary-700 font-medium">
    CARNIVAL TOURS podrá modificar servicios o cancelarlos, informando
    alternativas según políticas del proveedor. La interrupción voluntaria del
    viaje no genera derecho a reembolso.
  </p>
</mat-dialog-content>
<mat-dialog-actions class="w-full !flex !justify-center !items-center">
  <app-button
    mat-dialog-close
    size="Modal"
    text="Cerrar"
    color="Secondary"
    [width]="isMobile ? 464 : 320" />
</mat-dialog-actions>
